import {
  MOCK_STRATEGY_1,
  MOCK_STRATEGY_2,
  MOCK_STRATEGY_3,
  MOCK_STRATEGY_4,
} from "../containers/SelectedProject/AdStrategyView/constants";

const inProd = process.env.NODE_ENV === "production";

export const config = {
  inProd,
  cookies: {
    consentCookieLabel:
      process.env.REACT_APP_CONSENT_COOKIE_LABEL || "consent-cookie",
  },
  emails: {
    salesEmail: process.env.REACT_APP_SALES_EMAIL || "sales@adinsights.ai",
    supportEmail:
      process.env.REACT_APP_SUPPORT_EMAIL || "support@adinsights.ai",
    teamEmail: process.env.REACT_APP_SUPPORT_EMAIL || "team@adinsights.ai",
  },
  links: {
    agentTaskManager: inProd
      ? process.env.REACT_APP_ATM_URL
      : "http://localhost:4444",
    baseClientURL: inProd
      ? process.env.REACT_APP_WEB_APP_URL
      : "http://localhost:3000",
    baseAPIURL: inProd
      ? process.env.REACT_APP_PROD_API_DOMAIN
      : process.env.REACT_APP_DEV_API_DOMAIN || "http://localhost:2222",
    landingPageClientURL: inProd
      ? process.env.REACT_APP_LANDING_PAGE_URL
      : "http://localhost:3001",
    stripeCustomerPortalURL: inProd
      ? "https://billing.stripe.com/p/login/14k00he561TqeaIfYY"
      : "https://billing.stripe.com/p/login/test_aEU7sK9ST2Ki0Xm9AA",
  },
  mixpanel: {
    token: process.env.REACT_APP_MIXPANEL_TOKEN || "token",
  },
  labels: {
    brandName: process.env.REACT_APP_BRAND_NAME || "AdInsights.ai",
  },
  mocks: {
    searchState: {
      pagination: {
        total: 15, // Total number of records
        totalPages: 3, // Total number of pages
        currentPage: 1, // Current page number
        limit: 3, // Items per page
        hasNextPage: true,
        hasPrevPage: false,
      },
      filters: {
        status: "all",
        companyName: "",
        growthStage: "",
        productStage: "",
        dateFrom: undefined,
        dateTo: undefined,
        location: "",
        priceRange: {
          min: 0,
          max: 0,
        },
      },
      sorting: {
        sortBy: "createdAt",
        sortOrder: -1, // MongoDB style: -1 for DESC, 1 for ASC
      },
    },
    projects: [
      {
        id: 0,
        basicCompanyInfo: {
          companyName: "Glowly Skincare",
          industrySector: "Beauty and Personal Care",
          companySize: 50,
          annualRevenueRange: "$5M+",
          geographicLocations: ["United States", "Canada", "United Kingdom"],
          yearsInBusiness: 4,
          currentGrowthStage: "Series A",
          websiteUrl: "https://www.glowlyskincare.com",
        },
        productServiceDetails: {
          coreDescription:
            "Glowly Skincare offers vegan, cruelty-free skincare products designed to nourish and rejuvenate the skin.",
          currentProductStage: "Scaling",
          primaryValueProposition:
            "Effective, clean skincare made accessible to all with science-backed ingredients.",
          keyFeaturesBenefits: [
            "Vegan",
            "Cruelty-Free",
            "Dermatologist-Tested",
            "Eco-Friendly Packaging",
          ],
          deliveryMethod: "Physical Product",
        },
        currentMarketPosition: {
          targetMarketDescription:
            "Millennials and Gen Z consumers aged 18-35, interested in skincare, sustainability, and wellness.",
          mainCompetitors: ["The Ordinary", "Glossier", "Herbivore Botanicals"],
          marketDifferentiators:
            "Affordable pricing, sustainable packaging, and personalized product recommendations powered by AI.",
        },
        customerSuccessMetrics: {
          commonPainPointsSolved: [
            "Finding affordable yet effective skincare",
            "Access to cruelty-free products",
            "Personalized skincare solutions",
          ],
          typicalRoi:
            "3.5x ROAS from targeted social media and influencer marketing campaigns",
        },
        businessGoals: {
          shortTermRevenueTargets:
            "$200,000 in monthly revenue within 6 months",
          longTermGrowthObjectives:
            "Expand product line to include body care and international markets within 2 years",
          targetMarketExpansion:
            "Enter the European and Southeast Asian markets",
        },
        budgetResourceAllocation: {
          customerAcquisitionCostTargets: "$30 CAC across paid social channels",
          marketingBudget:
            "$300,000 annual budget with focus on social media ads and influencer partnerships",
        },
        status: "active",
        agents: {
          icp: {
            status: "running",
            progress: 65,
            results: {
              analyzed_companies: 250,
              identified_patterns: 15,
              market_segments: 4,
            },
            performance: [
              { date: "2024-02-25", value: 20 },
              { date: "2024-02-26", value: 35 },
              { date: "2024-02-27", value: 45 },
              { date: "2024-02-28", value: 55 },
              { date: "2024-02-29", value: 65 },
            ],
          },
          strategy: {
            // status: "paused",
            status: "running",
            progress: 40,
            results: {
              leads_found: 180,
              qualified_leads: 85,
              pending_verification: 25,
            },
            performance: [
              { date: "2024-02-25", value: 10 },
              { date: "2024-02-26", value: 25 },
              { date: "2024-02-27", value: 30 },
              { date: "2024-02-28", value: 35 },
              { date: "2024-02-29", value: 40 },
            ],
          },
        },
      },
      {
        id: 1,
        basicCompanyInfo: {
          companyName: "Salesly CRM",
          industrySector: "SaaS - Customer Relationship Management",
          companySize: 75,
          annualRevenueRange: "$5M+",
          geographicLocations: ["United States", "Australia", "Germany"],
          yearsInBusiness: 5,
          currentGrowthStage: "Series B+",
          websiteUrl: "https://www.saleslycrm.com",
        },
        productServiceDetails: {
          coreDescription:
            "Salesly CRM is an AI-powered platform that helps SMBs manage their sales pipeline, automate workflows, and boost customer engagement.",
          currentProductStage: "Scaling",
          primaryValueProposition:
            "AI-driven CRM solutions that simplify sales processes, improve customer relationships, and drive revenue growth.",
          keyFeaturesBenefits: [
            "AI-Powered Sales Automation",
            "Pipeline Management",
            "Customizable Dashboards",
            "Seamless Integrations with Marketing Tools",
          ],
          deliveryMethod: "SaaS",
        },
        currentMarketPosition: {
          targetMarketDescription:
            "Small and mid-sized businesses across industries such as retail, real estate, and professional services seeking to optimize their sales processes.",
          mainCompetitors: ["HubSpot", "Pipedrive", "Zoho CRM"],
          marketDifferentiators:
            "Affordable pricing, AI-driven insights, and intuitive user interface tailored for SMBs.",
        },
        customerSuccessMetrics: {
          commonPainPointsSolved: [
            "Manual and time-consuming sales processes",
            "Lack of data-driven insights",
            "Difficulty managing customer relationships at scale",
          ],
          typicalRoi:
            "4x ROAS through optimized sales automation and improved lead conversions",
        },
        businessGoals: {
          shortTermRevenueTargets: "$300,000 in MRR within 9 months",
          longTermGrowthObjectives:
            "Expand product features to include AI-driven marketing automation and enter APAC markets within 3 years",
          targetMarketExpansion: "SMBs in Asia-Pacific and Latin America",
        },
        budgetResourceAllocation: {
          customerAcquisitionCostTargets:
            "$40 CAC through paid search and social channels",
          marketingBudget:
            "$500,000 annual budget focused on digital ads, content marketing, and partner programs",
        },
        agents: {
          icp: {
            status: "running",
            progress: 65,
            results: {
              analyzed_companies: 250,
              identified_patterns: 15,
              market_segments: 4,
            },
            performance: [
              { date: "2024-02-25", value: 20 },
              { date: "2024-02-26", value: 35 },
              { date: "2024-02-27", value: 45 },
              { date: "2024-02-28", value: 55 },
              { date: "2024-02-29", value: 65 },
            ],
          },
          strategy: {
            status: "running",
            progress: 40,
            results: {
              leads_found: 180,
              qualified_leads: 85,
              pending_verification: 25,
            },
            performance: [
              { date: "2024-02-25", value: 10 },
              { date: "2024-02-26", value: 25 },
              { date: "2024-02-27", value: 30 },
              { date: "2024-02-28", value: 35 },
              { date: "2024-02-29", value: 40 },
            ],
          },
        },
      },
      {
        id: 2,
        basicCompanyInfo: {
          companyName: "LuxeFit Apparel",
          industrySector: "E-commerce - Activewear",
          companySize: 30,
          annualRevenueRange: "$5M+",
          geographicLocations: ["United States", "United Kingdom", "Australia"],
          yearsInBusiness: 3,
          currentGrowthStage: "Series A",
          websiteUrl: "https://www.luxefitapparel.com",
        },
        productServiceDetails: {
          coreDescription:
            "LuxeFit Apparel offers premium activewear designed for comfort, performance, and style, made from sustainable materials.",
          currentProductStage: "Scaling",
          primaryValueProposition:
            "High-performance, eco-friendly activewear that blends fashion with functionality for everyday athletes.",
          keyFeaturesBenefits: [
            "Sustainable Fabrics",
            "Moisture-Wicking Technology",
            "Inclusive Sizing",
            "Stylish Designs for Active Lifestyles",
          ],
          deliveryMethod: "Physical Product",
        },
        currentMarketPosition: {
          targetMarketDescription:
            "Fitness enthusiasts, yoga practitioners, and athleisure consumers aged 20-40 who prioritize sustainability and style.",
          mainCompetitors: ["Lululemon", "Outdoor Voices", "Gymshark"],
          marketDifferentiators:
            "Sustainable materials, inclusive sizing, and trend-forward designs at accessible prices.",
        },
        customerSuccessMetrics: {
          commonPainPointsSolved: [
            "Lack of stylish yet functional activewear",
            "Limited sustainable options in the market",
            "Finding high-quality activewear at reasonable prices",
          ],
          typicalRoi:
            "3x ROAS from data-driven social media and influencer campaigns across Instagram and TikTok",
        },
        businessGoals: {
          shortTermRevenueTargets:
            "$150,000 in monthly revenue within 6 months",
          longTermGrowthObjectives:
            "Expand product line to include accessories and open a flagship store within 3 years",
          targetMarketExpansion:
            "Increase market share in Europe and launch in Southeast Asia",
        },
        budgetResourceAllocation: {
          customerAcquisitionCostTargets:
            "$25 CAC through paid social and influencer collaborations",
          marketingBudget:
            "$250,000 annual budget with focus on Instagram Ads, TikTok campaigns, and influencer partnerships",
        },
        agents: {
          icp: {
            status: "running",
            progress: 65,
            results: {
              analyzed_companies: 250,
              identified_patterns: 15,
              market_segments: 4,
            },
            performance: [
              { date: "2024-02-25", value: 20 },
              { date: "2024-02-26", value: 35 },
              { date: "2024-02-27", value: 45 },
              { date: "2024-02-28", value: 55 },
              { date: "2024-02-29", value: 65 },
            ],
          },
          strategy: {
            status: "running",
            progress: 40,
            results: {
              leads_found: 180,
              qualified_leads: 85,
              pending_verification: 25,
            },
            performance: [
              { date: "2024-02-25", value: 10 },
              { date: "2024-02-26", value: 25 },
              { date: "2024-02-27", value: 30 },
              { date: "2024-02-28", value: 35 },
              { date: "2024-02-29", value: 40 },
            ],
          },
        },
      },
      {
        id: 3,
        basicCompanyInfo: {
          companyName: "NourishBox",
          industrySector: "Food & Beverage - Subscription Service",
          companySize: 40,
          annualRevenueRange: "$5M+",
          geographicLocations: ["United States", "Canada"],
          yearsInBusiness: 2,
          currentGrowthStage: "Seed",
          websiteUrl: "https://www.nourishbox.com",
        },
        productServiceDetails: {
          coreDescription:
            "NourishBox delivers curated, healthy meal kits and snacks to busy professionals, using organic and locally sourced ingredients.",
          currentProductStage: "Scaling",
          primaryValueProposition:
            "Convenient, nutritious meal solutions delivered to your door, with a focus on sustainability and quality.",
          keyFeaturesBenefits: [
            "Organic Ingredients",
            "Eco-Friendly Packaging",
            "Customizable Meal Plans",
            "Fast, Fresh Delivery",
          ],
          deliveryMethod: "Physical Product",
        },
        currentMarketPosition: {
          targetMarketDescription:
            "Health-conscious young professionals aged 25-45, living in urban areas, seeking convenient and healthy meal options.",
          mainCompetitors: ["HelloFresh", "Blue Apron", "Sunbasket"],
          marketDifferentiators:
            "Locally sourced ingredients, customizable meal plans, and a strong focus on sustainability.",
        },
        customerSuccessMetrics: {
          commonPainPointsSolved: [
            "Lack of time to prepare healthy meals",
            "Difficulty finding organic and sustainable food options",
            "Desire for variety in daily meals without hassle",
          ],
          typicalRoi:
            "2.8x ROAS from highly targeted social media and email marketing campaigns",
        },
        businessGoals: {
          shortTermRevenueTargets:
            "$100,000 in monthly recurring revenue within 4 months",
          longTermGrowthObjectives:
            "Expand subscription base by 50% and launch in the UK within 18 months",
          targetMarketExpansion: "Urban centers in Europe and Asia",
        },
        budgetResourceAllocation: {
          customerAcquisitionCostTargets:
            "$35 CAC through paid social, Google Ads, and influencer partnerships",
          marketingBudget:
            "$200,000 annual budget focused on social media, email marketing, and affiliate programs",
        },
        agents: {
          icp: {
            status: "running",
            progress: 65,
            results: {
              analyzed_companies: 250,
              identified_patterns: 15,
              market_segments: 4,
            },
            performance: [
              { date: "2024-02-25", value: 20 },
              { date: "2024-02-26", value: 35 },
              { date: "2024-02-27", value: 45 },
              { date: "2024-02-28", value: 55 },
              { date: "2024-02-29", value: 65 },
            ],
          },
          strategy: {
            status: "paused",
            progress: 40,
            results: {
              leads_found: 180,
              qualified_leads: 85,
              pending_verification: 25,
            },
            performance: [
              { date: "2024-02-25", value: 10 },
              { date: "2024-02-26", value: 25 },
              { date: "2024-02-27", value: 30 },
              { date: "2024-02-28", value: 35 },
              { date: "2024-02-29", value: 40 },
            ],
          },
        },
      },
    ],
    icps: [
      {
        project_id: "mock_project_id",
        name: "High-Growth Series B+ SaaS",
        status: "active",
        targeting: {
          professional: {
            titles: [
              "CTO",
              "VP Engineering",
              "Engineering Manager",
              "DevOps Lead",
            ],
            seniority: ["Director", "VP", "C-Level"],
            functions: ["Engineering", "DevOps", "Security", "Architecture"],
            tooling: [
              "GitHub Enterprise",
              "Jira",
              "CircleCI",
              "Kubernetes",
              "Terraform",
            ],
          },
          demographic: {
            locations: ["US Tech Hubs", "North America", "Europe"],
            experience: "5+ years in enterprise software",
            education: [
              "Computer Science",
              "Software Engineering",
              "Technical Fields",
            ],
          },
          industry: {
            sectors: ["Enterprise SaaS", "FinTech", "HealthTech"],
            companySize: ["100-500 employees", "$10M-$50M revenue"],
            companyType: ["Series B+", "High Growth", "Technology"],
          },
        },
        interests: {
          professional: {
            topics: [
              "DevOps Automation",
              "Cloud Architecture",
              "Scalability",
              "Security",
            ],
            skills: [
              "Cloud Infrastructure",
              "Microservices",
              "CI/CD",
              "Security",
            ],
            certifications: ["AWS", "Azure", "Security+", "CISSP"],
          },
          content: {
            formats: [
              "Technical Documentation",
              "Case Studies",
              "Webinars",
              "White Papers",
            ],
            topics: [
              "Technical Architecture",
              "DevOps",
              "Security Best Practices",
            ],
            platforms: [
              "GitHub",
              "Stack Overflow",
              "Tech Conferences",
              "LinkedIn",
            ],
          },
          engagement: {
            groups: [
              "Cloud Native Computing Foundation",
              "DevOps Enterprise Summit",
            ],
            events: ["KubeCon", "DevOps Days", "AWS re:Invent"],
            influencers: [
              "Tech Leaders",
              "Industry Analysts",
              "DevOps Thought Leaders",
            ],
          },
        },
        conversion: {
          intent: {
            signals: ["Technical Evaluation", "Security Review", "POC Request"],
            strength: "High",
            timeframe: "3-6 months",
          },
          authority: {
            level: "Decision Maker",
            constraints: [
              "Security Requirements",
              "Budget Approval",
              "Technical Validation",
            ],
            stakeholders: [
              "CTO",
              "Engineering VPs",
              "Security Team",
              "DevOps Team",
            ],
          },
          history: {
            engagements: [
              "Technical Documentation",
              "Product Demos",
              "Security Reviews",
            ],
            patterns: [
              "Multiple Team Members Involved",
              "Extended Evaluation Period",
            ],
            preferences: [
              "Self-Service Evaluation",
              "Technical Documentation",
              "Direct Support",
            ],
          },
          resources: {
            budgetRange: "$100k-$500k annually",
            approvalProcess: "C-Level + Board",
            constraints: [
              "Security Compliance",
              "Integration Requirements",
              "ROI Validation",
            ],
          },
        },
        metadata: {
          version: 1,
          confidence: 0.92,
          generatedBy: "ai",
          lastTested: new Date("2024-03-01"),
          performance: {
            impressions: 5000,
            clicks: 250,
            conversions: 15,
            costPerConversion: 1200,
          },
        },
      },
      {
        project_id: "mock_project_id",
        name: "Enterprise Healthcare Digital Transformation",
        status: "active",
        targeting: {
          professional: {
            titles: ["CIO", "CMIO", "IT Director", "Clinical Systems Director"],
            seniority: ["C-Level", "Director", "VP"],
            functions: ["IT", "Clinical Systems", "Compliance", "Operations"],
            tooling: ["Epic", "Cerner", "ServiceNow", "Azure DevOps"],
          },
          demographic: {
            locations: ["US Major Metro", "US Healthcare Markets"],
            experience: "10+ years in healthcare IT",
            education: [
              "Healthcare Administration",
              "Information Technology",
              "Clinical",
            ],
          },
          industry: {
            sectors: ["Healthcare", "Insurance", "Medical Devices"],
            companySize: ["1000+ employees", "$500M+ revenue"],
            companyType: ["Enterprise", "Healthcare Provider", "Payer"],
          },
        },
        interests: {
          professional: {
            topics: ["Digital Health", "Clinical Systems", "Healthcare IT"],
            skills: [
              "Healthcare Integration",
              "Clinical Workflows",
              "Compliance",
            ],
            certifications: ["HITRUST", "HIPAA", "ISO27001"],
          },
          content: {
            formats: ["Case Studies", "ROI Analysis", "Compliance Guides"],
            topics: ["Digital Transformation", "Patient Care", "Compliance"],
            platforms: [
              "Healthcare Conferences",
              "Industry Publications",
              "Webinars",
            ],
          },
          engagement: {
            groups: [
              "HIMSS",
              "Healthcare Information Management",
              "Clinical IT Forums",
            ],
            events: ["HIMSS Conference", "Healthcare IT Summit"],
            influencers: [
              "Healthcare CIOs",
              "Clinical Leaders",
              "Industry Analysts",
            ],
          },
        },
        conversion: {
          intent: {
            signals: [
              "RFP Participation",
              "Compliance Review",
              "Integration Assessment",
            ],
            strength: "High",
            timeframe: "12-18 months",
          },
          authority: {
            level: "Committee Decision",
            constraints: [
              "Regulatory Compliance",
              "Integration Requirements",
              "Training",
            ],
            stakeholders: [
              "Board",
              "C-Suite",
              "Clinical Leadership",
              "IT Directors",
            ],
          },
          history: {
            engagements: ["RFP Responses", "Compliance Reviews", "Site Visits"],
            patterns: ["Committee-Based Decision", "Long Sales Cycle"],
            preferences: [
              "Full Service Implementation",
              "Ongoing Support",
              "Training",
            ],
          },
          resources: {
            budgetRange: "$1M-$5M annually",
            approvalProcess: "Board + Committee",
            constraints: [
              "Budget Cycles",
              "Regulatory Requirements",
              "Integration Scope",
            ],
          },
        },
        metadata: {
          version: 1,
          confidence: 0.88,
          generatedBy: "ai",
          lastTested: new Date("2024-03-01"),
          performance: {
            impressions: 8000,
            clicks: 320,
            conversions: 8,
            costPerConversion: 2500,
          },
        },
      },
      {
        project_id: "mock_project_id",
        name: "Mid-Market FinTech Scale-Up",
        status: "active",
        targeting: {
          professional: {
            titles: [
              "Head of Product",
              "Product Manager",
              "Product Owner",
              "Technical PM",
            ],
            seniority: ["Manager", "Senior", "Head of"],
            functions: ["Product", "Technology", "Innovation", "Digital"],
            tooling: ["Jira", "Confluence", "Segment", "Mixpanel", "Amplitude"],
          },
          demographic: {
            locations: ["US Financial Centers", "UK", "Singapore"],
            experience: "3-7 years in fintech/product",
            education: ["Business", "Computer Science", "Economics"],
          },
          industry: {
            sectors: ["FinTech", "Banking", "Financial Services"],
            companySize: ["50-200 employees", "$5M-$20M revenue"],
            companyType: ["Series A", "Growth Stage", "Digital First"],
          },
        },
        interests: {
          professional: {
            topics: [
              "Product Analytics",
              "User Experience",
              "FinTech Innovation",
            ],
            skills: ["Product Strategy", "Agile", "Data Analytics", "UX"],
            certifications: ["PMP", "Agile", "Scrum"],
          },
          content: {
            formats: ["Product Demos", "Feature Updates", "ROI Calculators"],
            topics: ["Product Innovation", "FinTech Trends", "User Analytics"],
            platforms: ["ProductHunt", "Medium", "FinTech Forums"],
          },
          engagement: {
            groups: ["Product School", "FinTech Forums", "Product Tank"],
            events: ["Money20/20", "ProductCon", "FinTech Connect"],
            influencers: ["Product Leaders", "FinTech Innovators"],
          },
        },
        conversion: {
          intent: {
            signals: [
              "Product Demo Request",
              "Feature Comparison",
              "Pricing Inquiry",
            ],
            strength: "Medium-High",
            timeframe: "1-3 months",
          },
          authority: {
            level: "Recommender/Influencer",
            constraints: [
              "Budget",
              "Integration Timeline",
              "Feature Requirements",
            ],
            stakeholders: ["Product Head", "CTO", "Finance"],
          },
          history: {
            engagements: [
              "Product Demos",
              "Feature Discussions",
              "Trial Usage",
            ],
            patterns: ["Quick POC Requirements", "Feature-Driven Decision"],
            preferences: ["Self-Service Options", "API Documentation"],
          },
          resources: {
            budgetRange: "$50k-$150k annually",
            approvalProcess: "Head of Product + Finance",
            constraints: [
              "Feature Parity",
              "Integration Effort",
              "ROI Timeline",
            ],
          },
        },
        metadata: {
          version: 1,
          confidence: 0.89,
          generatedBy: "ai",
          lastTested: new Date("2024-03-01"),
          performance: {
            impressions: 4000,
            clicks: 180,
            conversions: 12,
            costPerConversion: 800,
          },
        },
      },
      {
        project_id: "mock_project_id",
        name: "Enterprise Security Solutions",
        status: "active",
        targeting: {
          professional: {
            titles: [
              "CISO",
              "Security Director",
              "Security Architect",
              "InfoSec Manager",
            ],
            seniority: ["Director", "VP", "C-Level"],
            functions: ["Security", "Risk", "Compliance", "IT"],
            tooling: ["Splunk", "Crowdstrike", "Okta", "Palo Alto"],
          },
          demographic: {
            locations: ["Global Fortune 2000 HQs", "Financial Centers"],
            experience: "10+ years in security",
            education: ["Computer Science", "Cybersecurity", "IT Security"],
          },
          industry: {
            sectors: ["Banking", "Insurance", "Healthcare", "Technology"],
            companySize: ["2000+ employees", "$1B+ revenue"],
            companyType: ["Enterprise", "Public Company", "Regulated Industry"],
          },
        },
        interests: {
          professional: {
            topics: ["Zero Trust", "Cloud Security", "Compliance"],
            skills: ["Security Architecture", "Risk Management", "Compliance"],
            certifications: ["CISSP", "CISM", "CEH"],
          },
          content: {
            formats: [
              "Security Whitepapers",
              "Threat Research",
              "Compliance Guides",
            ],
            topics: ["Security Strategy", "Threat Protection", "Compliance"],
            platforms: ["Security Conferences", "RSA", "Black Hat"],
          },
          engagement: {
            groups: ["ISC2", "ISACA", "Security Leadership"],
            events: ["RSA Conference", "Black Hat", "Gartner Security"],
            influencers: ["Security Analysts", "CISOs", "Research Firms"],
          },
        },
        conversion: {
          intent: {
            signals: [
              "Security Assessment",
              "Architecture Review",
              "Compliance Check",
            ],
            strength: "High",
            timeframe: "6-12 months",
          },
          authority: {
            level: "Decision Maker",
            constraints: [
              "Regulatory Requirements",
              "Integration",
              "Procurement",
            ],
            stakeholders: ["CISO", "Risk Committee", "Procurement"],
          },
          history: {
            engagements: [
              "Security Reviews",
              "Architecture Discussions",
              "POCs",
            ],
            patterns: ["Risk-Based Evaluation", "Compliance Focus"],
            preferences: [
              "White-Glove Service",
              "Direct Support",
              "Documentation",
            ],
          },
          resources: {
            budgetRange: "$500k-$2M annually",
            approvalProcess: "Security Committee + Procurement",
            constraints: ["Security Clearance", "Compliance", "Integration"],
          },
        },
        metadata: {
          version: 1,
          confidence: 0.94,
          generatedBy: "ai",
          lastTested: new Date("2024-03-01"),
          performance: {
            impressions: 6000,
            clicks: 240,
            conversions: 6,
            costPerConversion: 3000,
          },
        },
      },
    ],
    strategies: [
      MOCK_STRATEGY_1,
      MOCK_STRATEGY_2,
      MOCK_STRATEGY_3,
      MOCK_STRATEGY_4,
    ],
    insights: [
      {
        insights: {
          patterns: {
            platformSpecific: [
              {
                platform: "facebookAds",
                patterns: [
                  {
                    description:
                      "Video ads under 30 seconds show 45% higher engagement rates during evening hours",
                    improvement:
                      "Shift video ad scheduling to 6-10pm window and trim longer content",
                    confidence: 0.89,
                  },
                  {
                    description:
                      "Mobile-first creatives outperform desktop-optimized content by 2.3x",
                    improvement:
                      "Prioritize vertical video format and mobile-optimized CTAs",
                    confidence: 0.92,
                  },
                  {
                    description:
                      "Lookalike audiences based on high-LTV customers perform 75% better",
                    improvement:
                      "Expand lookalike audience targeting using top customer segment",
                    confidence: 0.85,
                  },
                ],
              },
              {
                platform: "googleAds",
                patterns: [
                  {
                    description:
                      "Long-tail keywords have 3.2x higher conversion rates than broad match",
                    improvement:
                      "Reallocate 40% of broad match budget to long-tail keywords",
                    confidence: 0.88,
                  },
                  {
                    description:
                      "Shopping campaigns see 28% higher ROAS on weekends",
                    improvement:
                      "Increase weekend budgets by 30% for shopping campaigns",
                    confidence: 0.91,
                  },
                ],
              },
              {
                platform: "tiktokAds",
                patterns: [
                  {
                    description:
                      "UGC-style content drives 2.1x higher click-through rates",
                    improvement: "Convert top-performing ads into UGC format",
                    confidence: 0.87,
                  },
                ],
              },
            ],
            crossPlatform: [
              {
                platforms: ["facebookAds", "instagramAds"],
                pattern:
                  "Story format ads consistently achieve 1.8x higher engagement than feed placements",
                impact: "Shift 35% of feed placement budget to story ads",
                confidence: 0.86,
              },
              {
                platforms: ["googleAds", "linkedinAds"],
                pattern:
                  "B2B campaigns show 2.4x higher conversion rates when running simultaneously",
                impact: "Synchronize B2B campaign scheduling across platforms",
                confidence: 0.82,
              },
              {
                platforms: ["tiktokAds", "instagramAds", "facebookAds"],
                pattern:
                  "Cross-platform video campaigns increase brand recall by 65%",
                impact:
                  "Implement unified video creative strategy across platforms",
                confidence: 0.88,
              },
            ],
          },
          recommendations: {
            budgetAdjustments: [
              {
                fromPlatform: "facebookAds",
                toPlatform: "tiktokAds",
                percentage: 20,
                reason:
                  "Higher engagement rates and lower CPM for target demographic",
              },
              {
                fromPlatform: "googleAds",
                toPlatform: "linkedinAds",
                percentage: 15,
                reason: "Superior B2B lead quality and conversion rates",
              },
            ],
            targeting: [
              {
                platform: "facebookAds",
                currentTarget: "18-45 age range, broad interests",
                recommendedTarget:
                  "25-34 age range, specific interest clusters",
                expectedImprovement: "35% increase in conversion rate",
              },
              {
                platform: "tiktokAds",
                currentTarget: "Gen Z broad targeting",
                recommendedTarget: "Interest-based micro-segments",
                expectedImprovement: "40% improvement in engagement",
              },
            ],
            creative: [
              {
                platform: "facebookAds",
                type: "video",
                recommendation:
                  "Create 15-second vertical story ads with strong first 3 seconds",
                expectedImpact: "28% increase in watch time and engagement",
              },
              {
                platform: "googleAds",
                type: "responsive",
                recommendation:
                  "Test expanded headline variations with industry keywords",
                expectedImpact: "15% improvement in CTR",
              },
            ],
          },
        },
      },
      {
        insights: {
          patterns: {
            platformSpecific: [
              {
                platform: "youtubeAds",
                patterns: [
                  {
                    description:
                      "Educational content over 5 minutes achieves 2.5x higher engagement rate",
                    improvement:
                      "Develop long-form educational content with chapter markers",
                    confidence: 0.91,
                  },
                  {
                    description:
                      "Industry expert testimonials drive 80% higher conversion rates",
                    improvement:
                      "Feature customer success stories and expert interviews",
                    confidence: 0.88,
                  },
                ],
              },
              {
                platform: "linkedinAds",
                patterns: [
                  {
                    description:
                      "Document ads outperform standard posts by 1.7x for B2B leads",
                    improvement:
                      "Convert key content pieces into document ad format",
                    confidence: 0.93,
                  },
                  {
                    description:
                      "Industry-specific targeting improves lead quality by 45%",
                    improvement:
                      "Segment campaigns by vertical with custom messaging",
                    confidence: 0.87,
                  },
                ],
              },
            ],
            crossPlatform: [
              {
                platforms: ["linkedinAds", "xAds"],
                pattern:
                  "Thought leadership content sees 2.1x higher engagement across platforms",
                impact:
                  "Develop unified thought leadership distribution strategy",
                confidence: 0.89,
              },
              {
                platforms: ["youtubeAds", "linkedinAds"],
                pattern:
                  "Educational video content repurposed across platforms increases conversions by 55%",
                impact: "Create modular video content for cross-platform usage",
                confidence: 0.85,
              },
            ],
          },
          recommendations: {
            budgetAdjustments: [
              {
                fromPlatform: "facebookAds",
                toPlatform: "linkedinAds",
                percentage: 25,
                reason: "Higher B2B lead quality and engagement rates",
              },
            ],
            targeting: [
              {
                platform: "linkedinAds",
                currentTarget: "Broad industry targeting",
                recommendedTarget:
                  "Industry-specific segments with custom messaging",
                expectedImprovement: "45% increase in lead quality",
              },
            ],
            creative: [
              {
                platform: "youtubeAds",
                type: "long-form",
                recommendation:
                  "Create 5-10 minute educational content with clear chapters",
                expectedImpact: "150% increase in engagement time",
              },
            ],
          },
        },
      },
      {
        insights: {
          patterns: {
            platformSpecific: [
              {
                platform: "xAds",
                patterns: [
                  {
                    description:
                      "Thread-based content achieves 3.1x higher engagement",
                    improvement:
                      "Convert key messages into thread format with clear CTAs",
                    confidence: 0.86,
                  },
                  {
                    description:
                      "Industry hashtag targeting improves reach by 65%",
                    improvement: "Implement industry-specific hashtag strategy",
                    confidence: 0.84,
                  },
                ],
              },
              {
                platform: "instagramAds",
                patterns: [
                  {
                    description:
                      "Behind-the-scenes content drives 2.8x higher engagement",
                    improvement:
                      "Create company culture and product development stories",
                    confidence: 0.9,
                  },
                ],
              },
            ],
            crossPlatform: [
              {
                platforms: ["xAds", "linkedinAds"],
                pattern:
                  "Professional insights content performs 90% better during work hours",
                impact: "Optimize posting schedule for business hours",
                confidence: 0.92,
              },
              {
                platforms: ["instagramAds", "xAds"],
                pattern: "Visual storytelling increases brand recall by 75%",
                impact: "Develop consistent visual narrative across platforms",
                confidence: 0.88,
              },
            ],
          },
          recommendations: {
            budgetAdjustments: [
              {
                fromPlatform: "instagramAds",
                toPlatform: "xAds",
                percentage: 30,
                reason: "Higher B2B engagement and conversion rates",
              },
            ],
            targeting: [
              {
                platform: "xAds",
                currentTarget: "General business audience",
                recommendedTarget: "Industry-specific hashtags and topics",
                expectedImprovement: "65% increase in qualified reach",
              },
            ],
            creative: [
              {
                platform: "xAds",
                type: "threads",
                recommendation:
                  "Create educational thread series with visual elements",
                expectedImpact: "210% increase in engagement and saves",
              },
              {
                platform: "instagramAds",
                type: "stories",
                recommendation: "Develop day-in-the-life product usage series",
                expectedImpact: "180% increase in story completion rate",
              },
            ],
          },
        },
      },
      {
        insights: {
          patterns: {
            platformSpecific: [
              {
                platform: "snapchatAds",
                patterns: [
                  {
                    description:
                      "AR filters for product demos show 4.2x higher interaction",
                    improvement:
                      "Create interactive AR product visualization filters",
                    confidence: 0.89,
                  },
                  {
                    description:
                      "Professional audience targeting peaks during commute hours",
                    improvement:
                      "Schedule campaigns for morning and evening commutes",
                    confidence: 0.85,
                  },
                ],
              },
              {
                platform: "youtubeAds",
                patterns: [
                  {
                    description:
                      "Product tutorials under 3 minutes see 95% completion rate",
                    improvement:
                      "Optimize tutorial content for brevity and clarity",
                    confidence: 0.93,
                  },
                  {
                    description:
                      "Custom intent audiences outperform affinity by 2.4x",
                    improvement: "Expand custom intent audience targeting",
                    confidence: 0.87,
                  },
                ],
              },
            ],
            crossPlatform: [
              {
                platforms: ["snapchatAds", "tiktokAds"],
                pattern:
                  "Short-form product demos achieve 2.5x higher sharing rate",
                impact: "Create unified short-form demo strategy",
                confidence: 0.91,
              },
              {
                platforms: ["youtubeAds", "snapchatAds"],
                pattern:
                  "Multi-platform video campaigns improve brand lift by 85%",
                impact: "Develop coordinated video content strategy",
                confidence: 0.88,
              },
            ],
          },
          recommendations: {
            budgetAdjustments: [
              {
                fromPlatform: "tiktokAds",
                toPlatform: "snapchatAds",
                percentage: 25,
                reason:
                  "Superior professional audience engagement during commute hours",
              },
              {
                fromPlatform: "facebookAds",
                toPlatform: "youtubeAds",
                percentage: 20,
                reason: "Higher completion rates for educational content",
              },
            ],
            targeting: [
              {
                platform: "snapchatAds",
                currentTarget: "Broad professional audience",
                recommendedTarget:
                  "Commute-time targeting with professional filters",
                expectedImprovement: "85% increase in qualified interactions",
              },
              {
                platform: "youtubeAds",
                currentTarget: "Affinity audiences",
                recommendedTarget: "Custom intent audience expansion",
                expectedImprovement: "140% improvement in conversion rate",
              },
            ],
            creative: [
              {
                platform: "snapchatAds",
                type: "AR",
                recommendation: "Develop product visualization AR experiences",
                expectedImpact: "320% increase in interaction time",
              },
              {
                platform: "youtubeAds",
                type: "tutorial",
                recommendation: "Create concise 2-3 minute feature tutorials",
                expectedImpact: "95% average completion rate",
              },
            ],
          },
        },
      },
    ],
    competitiveAnalysisReports: [
      {
        _id: "67aabf1780d7ea598769d0b4",
        project_id: "679eed87bc51456144f11414",
        icp_id: "67a56c9760dd671f2196bd54",
        name: "competitive-analysis-p:679eed87bc51456144f11414-icp:67a56c9760dd671f2196bd54",
        analysis: {
          initialAnalysis:
            '{\n    "marketOpportunities": {\n        "immediateOpportunities": [{\n            "opportunity": "Expand into the APAC region",\n            "potentialImpact": "Access to a large market with increasing demand for workflow automation solutions.",\n            "timeToRealize": "6-12 months",\n            "requiredResources": ["Market research team", "Local partnerships", "Sales and marketing budget"]\n        }],\n        "longTermOpportunities": [{\n            "opportunity": "Develop AI-powered predictive analytics features",\n            "marketSize": "$10B+ in enterprise software market",\n            "timelineToMarket": "12-18 months",\n            "potentialBarriers": ["Technical complexity", "Integration with existing systems", "Market competition"]\n        }]\n    },\n    "competitiveAdvantages": {\n        "currentAdvantages": [{\n            "advantage": "Proprietary AI algorithms",\n            "strengthLevel": "high",\n            "sustainability": "High due to continuous innovation and R&D investment.",\n            "competitorParity": ["CompetitorA", "CompetitorB"]\n        }, {\n            "advantage": "Fastest implementation time (2 weeks)",\n            "strengthLevel": "high",\n            "sustainability": "High as it enhances customer satisfaction and retention.",\n            "competitorParity": ["CompetitorC"]\n        }],\n        "potentialAdvantages": [{\n            "advantage": "Enhanced customer support with 24/7 availability",\n            "developmentNeeds": ["Hiring additional support staff", "Training programs"],\n            "timeToAchieve": "3-6 months",\n            "expectedImpact": "Increase in customer satisfaction and retention rates."\n        }]\n    },\n    "marketThreats": [{\n        "threat": "Intense competition from established players",\n        "severity": "high",\n        "likelihood": "very-likely",\n        "potentialImpact": "Loss of market share and reduced pricing power.",\n        "mitigationStrategies": ["Enhance product differentiation", "Increase marketing efforts", "Focus on customer success stories"]\n    }, {\n        "threat": "Regulatory changes affecting data privacy",\n        "severity": "medium",\n        "likelihood": "likely",\n        "potentialImpact": "Increased compliance costs and potential fines.",\n        "mitigationStrategies": ["Invest in compliance training", "Regular audits", "Engage with legal experts"]\n    }],\n    "summary": {\n        "overallPosition": "Housing Data Labs is well-positioned to capitalize on the growing demand for AI-powered workflow automation in enterprise settings, but must navigate competitive pressures and regulatory challenges.",\n        "keyFindings": [\n            "High customer retention rate (95%) indicates strong product-market fit.",\n            "Significant market demand for workflow automation solutions.",\n            "Potential for growth in APAC and new industries."\n        ],\n        "criticalActions": [\n            "Accelerate market entry into APAC.",\n            "Develop predictive analytics features.",\n            "Enhance customer support capabilities."\n        ],\n        "timelinePriorities": {\n            "immediate": ["Launch marketing campaign for APAC entry", "Conduct customer feedback sessions"],\n            "shortTerm": ["Develop predictive analytics features", "Expand sales team"],\n            "longTerm": ["Prepare for IPO", "Establish partnerships in new markets"]\n        }\n    }\n}',
          competitorAnalysis:
            '{\n    "competitors": [\n        {\n            "name": "AISolutions",\n            "profileAnalysis": {\n                "marketShare": "Emerging",\n                "revenueEstimate": "$1-3M annually",\n                "geographicPresence": ["Global"],\n                "targetMarkets": ["Enterprise"]\n            },\n            "strengths": [\n                {\n                    "category": "technology",\n                    "description": "Strong Cybersecurity expertise and innovative technology",\n                    "impactLevel": "high",\n                    "sustainabilityScore": 8\n                }\n            ],\n            "weaknesses": [\n                {\n                    "category": "distribution",\n                    "description": "Limited market reach",\n                    "exploitabilityScore": 7,\n                    "potentialStrategy": "Expand marketing efforts in underrepresented regions"\n                }\n            ],\n            "productOffering": {\n                "mainProducts": ["Cybersecurity solutions", "Consulting services"],\n                "uniqueFeatures": ["Advanced features", "Industry-leading solutions"],\n                "pricingStrategy": "Premium pricing",\n                "competitiveAdvantage": "Industry-leading cybersecurity solutions"\n            },\n            "marketStrategy": {\n                "primaryChannels": ["Direct Sales", "Content Marketing"],\n                "messageThemes": ["Advanced security", "Global expansion"],\n                "customerSegments": ["Enterprise"],\n                "partnershipStrategy": "Collaborate with global cybersecurity firms"\n            },\n            "threatLevel": {\n                "overall": "medium",\n                "specificThreats": [\n                    {\n                        "description": "Emerging cybersecurity startups",\n                        "probability": 0.6,\n                        "impact": "High"\n                    }\n                ]\n            }\n        },\n        {\n            "name": "CloudSolutions",\n            "profileAnalysis": {\n                "marketShare": "Challenger",\n                "revenueEstimate": "$2-4M annually",\n                "geographicPresence": ["Regional"],\n                "targetMarkets": ["SMBs"]\n            },\n            "strengths": [\n                {\n                    "category": "technology",\n                    "description": "Strong FinTech expertise and innovative technology",\n                    "impactLevel": "high",\n                    "sustainabilityScore": 7\n                }\n            ],\n            "weaknesses": [\n                {\n                    "category": "marketing",\n                    "description": "High customer acquisition costs",\n                    "exploitabilityScore": 6,\n                    "potentialStrategy": "Optimize marketing channels to reduce costs"\n                }\n            ],\n            "productOffering": {\n                "mainProducts": ["FinTech solutions", "Consulting services"],\n                "uniqueFeatures": ["Advanced features", "Industry-leading solutions"],\n                "pricingStrategy": "Value-based pricing",\n                "competitiveAdvantage": "Industry-leading fintech solutions"\n            },\n            "marketStrategy": {\n                "primaryChannels": ["Direct Sales", "Partner Network"],\n                "messageThemes": ["Cost-effective solutions", "Innovation in finance"],\n                "customerSegments": ["SMBs"],\n                "partnershipStrategy": "Form alliances with local financial institutions"\n            },\n            "threatLevel": {\n                "overall": "medium",\n                "specificThreats": [\n                    {\n                        "description": "Established FinTech giants",\n                        "probability": 0.7,\n                        "impact": "Medium"\n                    }\n                ]\n            }\n        },\n        {\n            "name": "TechTech",\n            "profileAnalysis": {\n                "marketShare": "Visionary",\n                "revenueEstimate": "$3-5M annually",\n                "geographicPresence": ["Global"],\n                "targetMarkets": ["Mid-market"]\n            },\n            "strengths": [\n                {\n                    "category": "product",\n                    "description": "Strong Digital Marketing expertise and innovative technology",\n                    "impactLevel": "high",\n                    "sustainabilityScore": 8\n                }\n            ],\n            "weaknesses": [\n                {\n                    "category": "competition",\n                    "description": "Strong competition in key markets",\n                    "exploitabilityScore": 8,\n                    "potentialStrategy": "Differentiate through unique service offerings"\n                }\n            ],\n            "productOffering": {\n                "mainProducts": ["Digital Marketing solutions", "Consulting services"],\n                "uniqueFeatures": ["Advanced features", "Industry-leading solutions"],\n                "pricingStrategy": "Tiered subscription",\n                "competitiveAdvantage": "Industry-leading digital marketing solutions"\n            },\n            "marketStrategy": {\n                "primaryChannels": ["Content Marketing", "Direct Sales"],\n                "messageThemes": ["Innovative marketing solutions", "Global reach"],\n                "customerSegments": ["Mid-market"],\n                "partnershipStrategy": "Collaborate with marketing agencies"\n            },\n            "threatLevel": {\n                "overall": "high",\n                "specificThreats": [\n                    {\n                        "description": "Emerging digital marketing platforms",\n                        "probability": 0.8,\n                        "impact": "High"\n                    }\n                ]\n            }\n        },\n        {\n            "name": "NovaTech",\n            "profileAnalysis": {\n                "marketShare": "Challenger",\n                "revenueEstimate": "$2-4M annually",\n                "geographicPresence": ["Regional"],\n                "targetMarkets": ["Enterprise"]\n            },\n            "strengths": [\n                {\n                    "category": "technology",\n                    "description": "Strong EdTech expertise and innovative technology",\n                    "impactLevel": "high",\n                    "sustainabilityScore": 7\n                }\n            ],\n            "weaknesses": [\n                {\n                    "category": "distribution",\n                    "description": "Limited market reach",\n                    "exploitabilityScore": 6,\n                    "potentialStrategy": "Expand into new geographic markets"\n                }\n            ],\n            "productOffering": {\n                "mainProducts": ["EdTech solutions", "Consulting services"],\n                "uniqueFeatures": ["Advanced features", "Industry-leading solutions"],\n                "pricingStrategy": "Custom enterprise pricing",\n                "competitiveAdvantage": "Industry-leading edtech solutions"\n            },\n            "marketStrategy": {\n                "primaryChannels": ["Direct Sales", "Content Marketing"],\n                "messageThemes": ["Innovative education solutions", "Enterprise focus"],\n                "customerSegments": ["Enterprise"],\n                "partnershipStrategy": "Partner with educational institutions"\n            },\n            "threatLevel": {\n                "overall": "medium",\n                "specificThreats": [\n                    {\n                        "description": "New entrants in the EdTech space",\n                        "probability": 0.5,\n                        "impact": "Medium"\n                    }\n                ]\n            }\n        },\n        {\n            "name": "SmartTech",\n            "profileAnalysis": {\n                "marketShare": "Emerging",\n                "revenueEstimate": "$2-4M annually",\n                "geographicPresence": ["Global"],\n                "targetMarkets": ["SMBs"]\n            },\n            "strengths": [\n                {\n                    "category": "technology",\n                    "description": "Strong E-commerce expertise and innovative technology",\n                    "impactLevel": "high",\n                    "sustainabilityScore": 8\n                }\n            ],\n            "weaknesses": [\n                {\n                    "category": "marketing",\n                    "description": "High customer acquisition costs",\n                    "exploitabilityScore": 7,\n                    "potentialStrategy": "Enhance digital marketing strategies"\n                }\n            ],\n            "productOffering": {\n                "mainProducts": ["E-commerce solutions", "Consulting services"],\n                "uniqueFeatures": ["Advanced features", "Industry-leading solutions"],\n                "pricingStrategy": "Premium pricing",\n                "competitiveAdvantage": "Industry-leading e-commerce solutions"\n            },\n            "marketStrategy": {\n                "primaryChannels": ["Direct Sales", "Content Marketing"],\n                "messageThemes": ["Innovative e-commerce solutions", "Global reach"],\n                "customerSegments": ["SMBs"],\n                "partnershipStrategy": "Collaborate with e-commerce platforms"\n            },\n            "threatLevel": {\n                "overall": "medium",\n                "specificThreats": [\n                    {\n                        "description": "Established e-commerce giants",\n                        "probability": 0.7,\n                        "impact": "High"\n                    }\n                ]\n            }\n        }\n    ],\n    "competitiveLandscape": {\n        "marketDynamics": {\n            "dominantPlayers": ["TechTech", "AIStream", "NovaLabs"],\n            "emergingThreats": ["New startups in AI and automation"],\n            "marketTrends": ["Increased demand for automation", "Focus on data security"]\n        },\n        "competitiveIntensity": {\n            "overallLevel": "high",\n            "keyFactors": ["Innovation", "Customer service", "Pricing"],\n            "futureProjection": "Continued growth with increased competition"\n        }\n    }\n}',
          recommendations:
            '{\n    "strategicPriorities": [{\n        "priority": "Expand into the APAC region",\n        "rationale": "Access to a large market with increasing demand for workflow automation solutions.",\n        "timeframe": "immediate",\n        "requiredResources": [\n            "Market research team",\n            "Local partnerships",\n            "Sales and marketing budget"\n        ],\n        "expectedOutcomes": [\n            "Increased market share",\n            "Revenue growth from new customers",\n            "Enhanced brand recognition in APAC"\n        ]\n    }, {\n        "priority": "Develop AI-powered predictive analytics features",\n        "rationale": "To capture a significant share of the $10B+ enterprise software market and enhance product offerings.",\n        "timeframe": "short-term",\n        "requiredResources": [\n            "R&D team",\n            "Technical partnerships",\n            "Development budget"\n        ],\n        "expectedOutcomes": [\n            "Improved product differentiation",\n            "Attraction of new enterprise clients",\n            "Increased customer retention"\n        ]\n    }, {\n        "priority": "Enhance customer support capabilities",\n        "rationale": "To increase customer satisfaction and retention rates, leveraging the existing high retention rate.",\n        "timeframe": "short-term",\n        "requiredResources": [\n            "Hiring additional support staff",\n            "Training programs"\n        ],\n        "expectedOutcomes": [\n            "Higher customer satisfaction scores",\n            "Reduced churn rate",\n            "Improved NPS"\n        ]\n    }],\n    "marketPositioning": {\n        "recommendedPosition": "Leader in AI-powered workflow automation for enterprise clients",\n        "targetSegments": [{\n            "segment": "Enterprise technology companies",\n            "reason": "High demand for automation solutions and existing customer base.",\n            "potentialValue": "$15M ARR target"\n        }, {\n            "segment": "Financial services",\n            "reason": "Strong interest and positive response to AI capabilities.",\n            "potentialValue": "$10M+ in potential contracts"\n        }],\n        "differentiators": [{\n            "feature": "Proprietary AI algorithms",\n            "competitiveAdvantage": "High sustainability due to continuous innovation.",\n            "sustainability": "High"\n        }, {\n            "feature": "Fastest implementation time (2 weeks)",\n            "competitiveAdvantage": "Enhances customer satisfaction and retention.",\n            "sustainability": "High"\n        }],\n        "messaging": {\n            "corePitch": "Transform your enterprise workflows with AI-powered automation.",\n            "keyMessages": [\n                "Reduce manual workflow time by 75%",\n                "Achieve 300% ROI within the first year",\n                "Seamless integration with existing systems"\n            ],\n            "valueProposition": "Empower your teams to focus on strategic initiatives while we handle the automation."\n        }\n    },\n    "actionPlan": {\n        "immediate": [{\n            "action": "Launch marketing campaign for APAC entry",\n            "priority": "critical",\n            "resources": [\n                "Marketing team",\n                "Budget for digital marketing"\n            ],\n            "timeline": "1 month",\n            "expectedImpact": "Increased brand awareness and lead generation in APAC"\n        }, {\n            "action": "Conduct customer feedback sessions",\n            "priority": "high",\n            "resources": [\n                "Customer success team",\n                "Survey tools"\n            ],\n            "timeline": "1 month",\n            "expectedImpact": "Insights for product improvement and customer satisfaction"\n        }],\n        "shortTerm": [{\n            "action": "Develop predictive analytics features",\n            "priority": "critical",\n            "requirements": [\n                "R&D resources",\n                "Technical partnerships"\n            ],\n            "timeline": "6 months",\n            "objectives": [\n                "Launch new features by Q3",\n                "Increase customer engagement"\n            ]\n        }, {\n            "action": "Expand sales team",\n            "priority": "high",\n            "requirements": [\n                "Recruitment budget",\n                "Training programs"\n            ],\n            "timeline": "3 months",\n            "objectives": [\n                "Increase sales capacity",\n                "Improve lead conversion rates"\n            ]\n        }],\n        "longTerm": [{\n            "action": "Prepare for IPO",\n            "priority": "critical",\n            "strategicValue": "Position the company for significant growth and investment opportunities.",\n            "timeline": "18-24 months",\n            "milestones": [\n                "Achieve $15M ARR",\n                "Establish strong market presence in APAC"\n            ]\n        }, {\n            "action": "Establish partnerships in new markets",\n            "priority": "high",\n            "strategicValue": "Leverage local expertise to enhance market entry strategies.",\n            "timeline": "12-18 months",\n            "milestones": [\n                "Identify key partners in APAC",\n                "Formalize partnerships"\n            ]\n        }]\n    },\n    "riskMitigation": {\n        "identifiedRisks": [{\n            "risk": "Intense competition from established players",\n            "likelihood": "high",\n            "impact": "severe",\n            "mitigationStrategy": "Enhance product differentiation and increase marketing efforts."\n        }, {\n            "risk": "Regulatory changes affecting data privacy",\n            "likelihood": "medium",\n            "impact": "moderate",\n            "mitigationStrategy": "Invest in compliance training and engage with legal experts."\n        }],\n        "contingencyPlans": [{\n            "trigger": "Significant drop in customer acquisition",\n            "response": "Reassess marketing strategies and customer engagement efforts.",\n            "requiredPreparation": [\n                "Market analysis tools",\n                "Customer feedback mechanisms"\n            ]\n        }]\n    },\n    "resourceAllocation": {\n        "recommended": [{\n            "area": "Marketing",\n            "allocation": "$2M annual budget",\n            "justification": "To support aggressive market entry and brand awareness initiatives.",\n            "expectedReturn": "Increased lead generation and market share."\n        }, {\n            "area": "R&D",\n            "allocation": "20% of revenue",\n            "justification": "To develop new features and maintain competitive advantage.",\n            "expectedReturn": "Enhanced product offerings and customer satisfaction."\n        }],\n        "priorities": {\n            "immediate": [\n                "Market research for APAC",\n                "Hiring additional support staff"\n            ],\n            "nextQuarter": [\n                "Launch predictive analytics features",\n                "Expand sales team"\n            ],\n            "nextYear": [\n                "Prepare for IPO",\n                "Establish partnerships in new markets"\n            ]\n        }\n    }\n}',
        },
        createdAt: "2025-02-11T03:08:07.302Z",
        updatedAt: "2025-02-11T03:08:07.302Z",
        __v: 0,
      },
      {
        _id: "1fd44f8126db422e8e8ee6870e91fd3d",
        project_id: "679eed87bc51456144f11414",
        icp_id: "67a56c9760dd671f2196bd54",
        name: "competitive-analysis-p:679eed87bc51456144f11414-icp:67a56c9760dd671f2196bd54",
        analysis: {
          initialAnalysis:
            '{"marketOpportunities":{"immediateOpportunities":[{"opportunity":"Expand into the European market","potentialImpact":"Access to mature market with high adoption of digital solutions.","timeToRealize":"6-12 months","requiredResources":["Local sales team","Regulatory compliance","Marketing budget"]}],"longTermOpportunities":[{"opportunity":"Develop blockchain integration capabilities","marketSize":"$8B+ in enterprise blockchain market","timelineToMarket":"12-18 months","potentialBarriers":["Technical expertise","Market education","Regulatory compliance"]}]},"competitiveAdvantages":{"currentAdvantages":[{"advantage":"Advanced machine learning algorithms","strengthLevel":"high","sustainability":"High due to continuous R&D investment.","competitorParity":["CompetitorX","CompetitorY"]}],"potentialAdvantages":[{"advantage":"Automated customer onboarding process","developmentNeeds":["UI/UX improvements","Integration capabilities"],"timeToAchieve":"3-6 months","expectedImpact":"50% reduction in onboarding time."}]},"marketThreats":[{"threat":"New entrants with innovative technology","severity":"high","likelihood":"very-likely","potentialImpact":"Market share erosion and pricing pressure.","mitigationStrategies":["Accelerate innovation","Strengthen customer relationships"]}],"summary":{"overallPosition":"Company maintains strong position in enterprise software but faces increasing competition.","keyFindings":["High product adoption rate in target markets","Growing demand for integrated solutions","Opportunity for European expansion"],"criticalActions":["Launch European operations","Develop blockchain capabilities","Enhance onboarding process"],"timelinePriorities":{"immediate":["Establish European presence","Customer feedback analysis"],"shortTerm":["Blockchain feature development","Sales team expansion"],"longTerm":["Global expansion","Strategic acquisitions"]}}}',
          competitorAnalysis:
            '{"competitors":[{"name":"TechInnovate","profileAnalysis":{"marketShare":"Leader","revenueEstimate":"$5-7M annually","geographicPresence":["Global"],"targetMarkets":["Enterprise"]},"strengths":[{"category":"technology","description":"Advanced AI capabilities and proven scalability","impactLevel":"high","sustainabilityScore":9}],"weaknesses":[{"category":"support","description":"Limited customer support coverage","exploitabilityScore":7,"potentialStrategy":"Expand support team and coverage hours"}],"productOffering":{"mainProducts":["Enterprise AI Platform","Consulting services"],"uniqueFeatures":["Advanced AI","Scalable infrastructure"],"pricingStrategy":"Enterprise pricing","competitiveAdvantage":"Market-leading AI capabilities"},"marketStrategy":{"primaryChannels":["Direct Sales","Partner Network"],"messageThemes":["Enterprise-grade AI","Global scale"],"customerSegments":["Enterprise"],"partnershipStrategy":"Strategic technology partnerships"},"threatLevel":{"overall":"high","specificThreats":[{"description":"New AI startups","probability":0.8,"impact":"High"}]}}],"competitiveLandscape":{"marketDynamics":{"dominantPlayers":["TechInnovate","GlobalAI","EnterpriseCore"],"emergingThreats":["AI startups","Cloud providers"],"marketTrends":["AI adoption","Cloud integration"]},"competitiveIntensity":{"overallLevel":"high","keyFactors":["Technology","Scale","Support"],"futureProjection":"Increasing competition in AI space"}}}',
          recommendations:
            '{"strategicPriorities":[{"priority":"European market expansion","rationale":"Access to mature market with high digital adoption.","timeframe":"immediate","requiredResources":["Local sales team","Regulatory compliance","Marketing budget"],"expectedOutcomes":["Market presence in EU","Revenue growth","Brand recognition"]}],"marketPositioning":{"recommendedPosition":"Enterprise AI leader with global reach","targetSegments":[{"segment":"Large enterprises","reason":"High adoption potential and budget availability.","potentialValue":"$20M ARR target"}],"differentiators":[{"feature":"Advanced AI capabilities","competitiveAdvantage":"Superior accuracy and scale","sustainability":"High"}],"messaging":{"corePitch":"Enterprise AI that scales with your business","keyMessages":["99.9% accuracy","Global scale","Enterprise support"],"valueProposition":"Transform your enterprise with proven AI solutions"}},"actionPlan":{"immediate":[{"action":"Launch EU operations","priority":"critical","resources":["Sales team","Marketing budget"],"timeline":"3 months","expectedImpact":"EU market presence"}],"shortTerm":[{"action":"Develop blockchain features","priority":"high","requirements":["Development team","Technology partnerships"],"timeline":"6 months","objectives":["Feature launch","Market adoption"]}],"longTerm":[{"action":"Global expansion","priority":"medium","strategicValue":"Market leadership","timeline":"18-24 months","milestones":["Regional offices","Partner network"]}]},"resourceAllocation":{"recommended":[{"area":"Sales","allocation":"$3M annual budget","justification":"Support global expansion","expectedReturn":"Revenue growth"}],"priorities":{"immediate":["EU market entry","Sales team expansion"],"nextQuarter":["Feature development","Partner program"],"nextYear":["Global expansion","Strategic acquisitions"]}}}',
        },
        createdAt: "2025-02-11T03:11:16.274Z",
        updatedAt: "2025-02-11T03:11:16.275Z",
        __v: 0,
      },
      {
        _id: "f1e2afdb768e4c0fbda6b72e18aa267b",
        project_id: "679eed87bc51456144f11414",
        icp_id: "67a56c9760dd671f2196bd54",
        name: "competitive-analysis-p:679eed87bc51456144f11414-icp:67a56c9760dd671f2196bd54",
        analysis: {
          initialAnalysis:
            '{"marketOpportunities":{"immediateOpportunities":[{"opportunity":"Expand into the European market","potentialImpact":"Access to mature market with high adoption of digital solutions.","timeToRealize":"6-12 months","requiredResources":["Local sales team","Regulatory compliance","Marketing budget"]}],"longTermOpportunities":[{"opportunity":"Develop blockchain integration capabilities","marketSize":"$8B+ in enterprise blockchain market","timelineToMarket":"12-18 months","potentialBarriers":["Technical expertise","Market education","Regulatory compliance"]}]},"competitiveAdvantages":{"currentAdvantages":[{"advantage":"Advanced machine learning algorithms","strengthLevel":"high","sustainability":"High due to continuous R&D investment.","competitorParity":["CompetitorX","CompetitorY"]}],"potentialAdvantages":[{"advantage":"Automated customer onboarding process","developmentNeeds":["UI/UX improvements","Integration capabilities"],"timeToAchieve":"3-6 months","expectedImpact":"50% reduction in onboarding time."}]},"marketThreats":[{"threat":"New entrants with innovative technology","severity":"high","likelihood":"very-likely","potentialImpact":"Market share erosion and pricing pressure.","mitigationStrategies":["Accelerate innovation","Strengthen customer relationships"]}],"summary":{"overallPosition":"Company maintains strong position in enterprise software but faces increasing competition.","keyFindings":["High product adoption rate in target markets","Growing demand for integrated solutions","Opportunity for European expansion"],"criticalActions":["Launch European operations","Develop blockchain capabilities","Enhance onboarding process"],"timelinePriorities":{"immediate":["Establish European presence","Customer feedback analysis"],"shortTerm":["Blockchain feature development","Sales team expansion"],"longTerm":["Global expansion","Strategic acquisitions"]}}}',
          competitorAnalysis:
            '{"competitors":[{"name":"TechInnovate","profileAnalysis":{"marketShare":"Leader","revenueEstimate":"$5-7M annually","geographicPresence":["Global"],"targetMarkets":["Enterprise"]},"strengths":[{"category":"technology","description":"Advanced AI capabilities and proven scalability","impactLevel":"high","sustainabilityScore":9}],"weaknesses":[{"category":"support","description":"Limited customer support coverage","exploitabilityScore":7,"potentialStrategy":"Expand support team and coverage hours"}],"productOffering":{"mainProducts":["Enterprise AI Platform","Consulting services"],"uniqueFeatures":["Advanced AI","Scalable infrastructure"],"pricingStrategy":"Enterprise pricing","competitiveAdvantage":"Market-leading AI capabilities"},"marketStrategy":{"primaryChannels":["Direct Sales","Partner Network"],"messageThemes":["Enterprise-grade AI","Global scale"],"customerSegments":["Enterprise"],"partnershipStrategy":"Strategic technology partnerships"},"threatLevel":{"overall":"high","specificThreats":[{"description":"New AI startups","probability":0.8,"impact":"High"}]}}],"competitiveLandscape":{"marketDynamics":{"dominantPlayers":["TechInnovate","GlobalAI","EnterpriseCore"],"emergingThreats":["AI startups","Cloud providers"],"marketTrends":["AI adoption","Cloud integration"]},"competitiveIntensity":{"overallLevel":"high","keyFactors":["Technology","Scale","Support"],"futureProjection":"Increasing competition in AI space"}}}',
          recommendations:
            '{"strategicPriorities":[{"priority":"European market expansion","rationale":"Access to mature market with high digital adoption.","timeframe":"immediate","requiredResources":["Local sales team","Regulatory compliance","Marketing budget"],"expectedOutcomes":["Market presence in EU","Revenue growth","Brand recognition"]}],"marketPositioning":{"recommendedPosition":"Enterprise AI leader with global reach","targetSegments":[{"segment":"Large enterprises","reason":"High adoption potential and budget availability.","potentialValue":"$20M ARR target"}],"differentiators":[{"feature":"Advanced AI capabilities","competitiveAdvantage":"Superior accuracy and scale","sustainability":"High"}],"messaging":{"corePitch":"Enterprise AI that scales with your business","keyMessages":["99.9% accuracy","Global scale","Enterprise support"],"valueProposition":"Transform your enterprise with proven AI solutions"}},"actionPlan":{"immediate":[{"action":"Launch EU operations","priority":"critical","resources":["Sales team","Marketing budget"],"timeline":"3 months","expectedImpact":"EU market presence"}],"shortTerm":[{"action":"Develop blockchain features","priority":"high","requirements":["Development team","Technology partnerships"],"timeline":"6 months","objectives":["Feature launch","Market adoption"]}],"longTerm":[{"action":"Global expansion","priority":"medium","strategicValue":"Market leadership","timeline":"18-24 months","milestones":["Regional offices","Partner network"]}]},"resourceAllocation":{"recommended":[{"area":"Sales","allocation":"$3M annual budget","justification":"Support global expansion","expectedReturn":"Revenue growth"}],"priorities":{"immediate":["EU market entry","Sales team expansion"],"nextQuarter":["Feature development","Partner program"],"nextYear":["Global expansion","Strategic acquisitions"]}}}',
        },
        createdAt: "2025-02-11T03:11:16.275Z",
        updatedAt: "2025-02-11T03:11:16.275Z",
        __v: 0,
      },
      {
        _id: "14a45041ea0d401ca2f90eb7a3167f09",
        project_id: "679eed87bc51456144f11414",
        icp_id: "67a56c9760dd671f2196bd54",
        name: "competitive-analysis-p:679eed87bc51456144f11414-icp:67a56c9760dd671f2196bd54",
        analysis: {
          initialAnalysis:
            '{"marketOpportunities":{"immediateOpportunities":[{"opportunity":"Expand into the European market","potentialImpact":"Access to mature market with high adoption of digital solutions.","timeToRealize":"6-12 months","requiredResources":["Local sales team","Regulatory compliance","Marketing budget"]}],"longTermOpportunities":[{"opportunity":"Develop blockchain integration capabilities","marketSize":"$8B+ in enterprise blockchain market","timelineToMarket":"12-18 months","potentialBarriers":["Technical expertise","Market education","Regulatory compliance"]}]},"competitiveAdvantages":{"currentAdvantages":[{"advantage":"Advanced machine learning algorithms","strengthLevel":"high","sustainability":"High due to continuous R&D investment.","competitorParity":["CompetitorX","CompetitorY"]}],"potentialAdvantages":[{"advantage":"Automated customer onboarding process","developmentNeeds":["UI/UX improvements","Integration capabilities"],"timeToAchieve":"3-6 months","expectedImpact":"50% reduction in onboarding time."}]},"marketThreats":[{"threat":"New entrants with innovative technology","severity":"high","likelihood":"very-likely","potentialImpact":"Market share erosion and pricing pressure.","mitigationStrategies":["Accelerate innovation","Strengthen customer relationships"]}],"summary":{"overallPosition":"Company maintains strong position in enterprise software but faces increasing competition.","keyFindings":["High product adoption rate in target markets","Growing demand for integrated solutions","Opportunity for European expansion"],"criticalActions":["Launch European operations","Develop blockchain capabilities","Enhance onboarding process"],"timelinePriorities":{"immediate":["Establish European presence","Customer feedback analysis"],"shortTerm":["Blockchain feature development","Sales team expansion"],"longTerm":["Global expansion","Strategic acquisitions"]}}}',
          competitorAnalysis:
            '{"competitors":[{"name":"TechInnovate","profileAnalysis":{"marketShare":"Leader","revenueEstimate":"$5-7M annually","geographicPresence":["Global"],"targetMarkets":["Enterprise"]},"strengths":[{"category":"technology","description":"Advanced AI capabilities and proven scalability","impactLevel":"high","sustainabilityScore":9}],"weaknesses":[{"category":"support","description":"Limited customer support coverage","exploitabilityScore":7,"potentialStrategy":"Expand support team and coverage hours"}],"productOffering":{"mainProducts":["Enterprise AI Platform","Consulting services"],"uniqueFeatures":["Advanced AI","Scalable infrastructure"],"pricingStrategy":"Enterprise pricing","competitiveAdvantage":"Market-leading AI capabilities"},"marketStrategy":{"primaryChannels":["Direct Sales","Partner Network"],"messageThemes":["Enterprise-grade AI","Global scale"],"customerSegments":["Enterprise"],"partnershipStrategy":"Strategic technology partnerships"},"threatLevel":{"overall":"high","specificThreats":[{"description":"New AI startups","probability":0.8,"impact":"High"}]}}],"competitiveLandscape":{"marketDynamics":{"dominantPlayers":["TechInnovate","GlobalAI","EnterpriseCore"],"emergingThreats":["AI startups","Cloud providers"],"marketTrends":["AI adoption","Cloud integration"]},"competitiveIntensity":{"overallLevel":"high","keyFactors":["Technology","Scale","Support"],"futureProjection":"Increasing competition in AI space"}}}',
          recommendations:
            '{"strategicPriorities":[{"priority":"European market expansion","rationale":"Access to mature market with high digital adoption.","timeframe":"immediate","requiredResources":["Local sales team","Regulatory compliance","Marketing budget"],"expectedOutcomes":["Market presence in EU","Revenue growth","Brand recognition"]}],"marketPositioning":{"recommendedPosition":"Enterprise AI leader with global reach","targetSegments":[{"segment":"Large enterprises","reason":"High adoption potential and budget availability.","potentialValue":"$20M ARR target"}],"differentiators":[{"feature":"Advanced AI capabilities","competitiveAdvantage":"Superior accuracy and scale","sustainability":"High"}],"messaging":{"corePitch":"Enterprise AI that scales with your business","keyMessages":["99.9% accuracy","Global scale","Enterprise support"],"valueProposition":"Transform your enterprise with proven AI solutions"}},"actionPlan":{"immediate":[{"action":"Launch EU operations","priority":"critical","resources":["Sales team","Marketing budget"],"timeline":"3 months","expectedImpact":"EU market presence"}],"shortTerm":[{"action":"Develop blockchain features","priority":"high","requirements":["Development team","Technology partnerships"],"timeline":"6 months","objectives":["Feature launch","Market adoption"]}],"longTerm":[{"action":"Global expansion","priority":"medium","strategicValue":"Market leadership","timeline":"18-24 months","milestones":["Regional offices","Partner network"]}]},"resourceAllocation":{"recommended":[{"area":"Sales","allocation":"$3M annual budget","justification":"Support global expansion","expectedReturn":"Revenue growth"}],"priorities":{"immediate":["EU market entry","Sales team expansion"],"nextQuarter":["Feature development","Partner program"],"nextYear":["Global expansion","Strategic acquisitions"]}}}',
        },
        createdAt: "2025-02-11T03:11:16.275Z",
        updatedAt: "2025-02-11T03:11:16.275Z",
        __v: 0,
      },
    ],
  },
};
